import PropTypes from 'prop-types';
import Link from './ui/Link';

export default function ListItem({ feature, categories, getLabel, editions, showLightbox }) {
	const displayGallery = (feature) => {
		if (feature.images === undefined && feature.popup_video === undefined) {
			return null;
		}
		const gallery = feature?.images || [];
		const videoID = feature?.popup_video || '';
		let thumbnail = '';

		if (videoID !== '') {
			thumbnail = `https://i.ytimg.com/vi/${videoID}/hqdefault.jpg`;
			const videoUrl = `https://youtu.be/${videoID}?feature=shared&no-cookie`;

			// if video not already in gallery
			if (!gallery.find((media) => media.url === videoUrl)) {
				gallery.unshift({
					type: 'video',
					url: videoUrl,
					title: 'Video',
				});
			}
		}

		return (
			<div className="list-item--gallery">
				<div className="list-item--gallery-wrapper">
					{gallery.map((media, index) => (
						<div key={index} className="list-item--gallery-item" onClick={() => showLightbox(feature.id, gallery)}>
							{'video' === media.type ? (
								<div className="wrapper-video">
									<video src={media.url} poster={thumbnail}></video>
								</div>
							) : (
								<div className="wrapper-image">
									<img src={media.url} alt={media.title} />
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		);
	};

	const getDetailedDescription = () => {
		if (!Object.keys(feature.detail_func).length) {
			return null;
		}

		return (
			<div className="list-item--detailed_description">
				<div className="list-item--sub-headline">{getLabel('detailed_description_headline')}</div>
				<ul>
					{Object.entries(feature.detail_func).map(([key, value]) => (
						<li dangerouslySetInnerHTML={{ __html: value }} key={key} className={value ? 'check' : 'cross'}></li>
					))}
				</ul>
			</div>
		);
	};

	return (
		<li className={`list-item ${feature.images || feature.popup_video ? 'list-item--media' : 'list-item--no-media'}`}>
			{displayGallery(feature)}

			<h6 className="list-item--headline" dangerouslySetInnerHTML={{ __html: feature.name }}></h6>

			{feature.primary_category && (
				<div className="list-item--category" style={{ '--color': categories[feature.primary_category].color }}>
					{categories[feature.primary_category].title}
				</div>
			)}

			<div className="list-item--description">
				<div className="list-item--sub-headline">{getLabel('description_headline')}</div>
				<div dangerouslySetInnerHTML={{ __html: feature.desc_list }}></div>
			</div>

			{editions.length ? (
				<div className="list-item--editions">
					<div className="list-item--sub-headline">{getLabel('edition_headline')}</div>
					<ul className="no-list">
						{editions.map((edition) => (
							<li key={edition.slug} className="list-item--icon" data-checked={feature.editions.includes(edition.slug)}>
								{edition.name}
							</li>
						))}
					</ul>
				</div>
			) : null}

			{getDetailedDescription()}

			{feature.content_url && (
				<div className="list-item--actions">
					<Link classes={['btn']} href={feature.content_url}>
						{getLabel('read_more')}
					</Link>
				</div>
			)}
		</li>
	);
}

ListItem.propTypes = {
	feature: PropTypes.object.isRequired,
	categories: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	editions: PropTypes.array.isRequired,
	showLightbox: PropTypes.func,
};
